import { AllowFeature } from 'app/model/feature/allow-feature.model';

export class BillingAddressFeature extends AllowFeature {

  constructor(featureData: any = undefined) {
    const isRequired = featureData && featureData.required === 'true';
    const isDiaplayed = featureData && featureData.display === 'true';
    super(!!isRequired, !!isDiaplayed);
  }
}



// WEBPACK FOOTER //
// ./src/app/model/feature/billing-address-feature.model.ts